import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ContratoEditarRoutingModule } from "./contrato-editar-routing.module";
import { ContratoEditarComponent } from "./contrato-editar.component";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { TableModule } from 'primeng/table';
import { TooltipModule } from "primeng/tooltip";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from "@angular/forms";
import { InputMaskModule } from 'primeng/inputmask';
import { MessagesModule } from 'primeng/messages';
import {InputSwitchModule} from 'primeng/inputswitch';
import { InputNumberModule } from "primeng/inputnumber";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ConfirmationService } from "primeng/api";
import { ProgressSpinnerModule } from "primeng/progressspinner";


@NgModule({
    imports: [
        CommonModule,
        ContratoEditarRoutingModule,
        FormsModule,
        TableModule,
        ButtonModule,
        InputTextModule,
        TooltipModule,
        DropdownModule,
        InputMaskModule,
        MessagesModule,
        InputSwitchModule,
        InputNumberModule,
        ConfirmDialogModule,
        ProgressSpinnerModule

    ],
    providers: [ConfirmationService],
    declarations: [ContratoEditarComponent]
})
export class ContratoEditarModule { }
